import { render, staticRenderFns } from "./StatsBySessionsChart.vue?vue&type=template&id=4818534c&"
import script from "./StatsBySessionsChart.vue?vue&type=script&lang=js&"
export * from "./StatsBySessionsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports